module.exports = __webpack_public_path__ + "img/luyuanDetailJf.7f2d6ef3.png";